import { createSlice } from '@reduxjs/toolkit'
import IntlMessages from 'components/Message/IntlMessages';
import { handleErrorStopLoading, handleFail, handleLoading } from 'redux/redux-util';

const initialState = {
  loading: false,
  accountsType: [
    { label: <IntlMessages id="private.wealth.management.register.account-type.single" />, value: '01' },
    { label: <IntlMessages id="private.wealth.management.register.account-type.multi" />, value: '02' },
  ],
  receiveMethodType: [
    { label: <IntlMessages id="private.wealth.management.address.receive-method.email" />, value: '01' },
    { label: <IntlMessages id="private.wealth.management.address.receive-method.address" />, value: '02' },
    // { label: <IntlMessages id="private.wealth.management.address.receive-method.non" />, value: '03' }
  ],
  receiveMethodSubType: [
    { label: <IntlMessages id="private.wealth.management.address.receive-method-sub.address" />, value: '04' },
    { label: <IntlMessages id="private.wealth.management.address.receive-method-sub.address-work" />, value: '05' },
  ],
  dividendAccountTypeList: [
    { label: <IntlMessages id="private.wealth.management.dividend.dividend-account-type.payment-account" />, value: '02' },
    //comment optional
    // { label: <IntlMessages id="private.wealth.management.dividend.dividend-account-type.cheque" />, value: '01' }
  ],
  // taxDeductionTypeList: [
  //   { label: <IntlMessages id="private.wealth.management.dividend.tax-deduction-type.accept" />, value: '01' },
  //   { label: <IntlMessages id="private.wealth.management.dividend.tax-deduction-type.non-accept" />, value: '02' }
  // ],
  maritalStatusList: [
    { label: <IntlMessages id="private.wealth.management.register.marital-status.single" />, value: '01' },
    { label: <IntlMessages id="private.wealth.management.register.marital-status.marry" />, value: '02' }
  ],
  investmentList: [
    { label: <IntlMessages id="private.wealth.management.investment.objectives.investment" />, value: '01' },
    { label: <IntlMessages id="private.wealth.management.investment.objectives.retirement" />, value: '02' },
    { label: <IntlMessages id="private.wealth.management.investment.objectives.tax-benefits" />, value: '03' },
    { label: <IntlMessages id="global.others" />, value: '99' },
  ],
  accountList: [],
  dataMemory: {},
};

const slice = createSlice({
  initialState,
  name: 'pwm',
  reducers: {
    getAccounts: handleLoading,
    getAccountsSuccess: (state, action) => {
      state.loading = false;
      state.accountList = action.payload;
      state.registerPWMStatus = false;
    },
    getAccountsFailure: handleFail,
    registerPWM: handleLoading,
    registerPWMSuccess: (state, action) => {
      state.loading = false;
      state.registerPWMStatus = true;
      state.dataMemory = { ...state.dataMemory ?? {}, };
      state.accountList = [];
    },
    registerPWMFailure: handleErrorStopLoading,
    saveDataMemory: (state, action) => {
      state.dataMemory = action.payload;
    },
    redirectSuitability: (state, action) => {
      state.dataMemory = action.payload;
    },
    redirectPWMRegister: (state, action) => {
      state.dataMemory = action.payload;
    },
    redirectDisclaimer1: (state, action) => {
      state.dataMemory = action.payload;
    },
    redirectDisclaimer2: (state, action) => {
      state.dataMemory = action.payload;
    }
  }
})

// export const redirectSuitability
//   = createAction('Register/Suitability')

export const {
  getAccounts,
  getAccountsSuccess,
  getAccountsFailure,
  registerPWM,
  registerPWMSuccess,
  registerPWMFailure,
  saveDataMemory,
  redirectSuitability,
  redirectPWMRegister,
  redirectDisclaimer1,
  redirectDisclaimer2,
} = slice.actions;

export default slice.reducer;